// extracted by mini-css-extract-plugin
export default {"wrapper":"People_wrapper__1IVlp"};